/* ------------------------------------------------------------------
   TBD — aide a la navigation (sections/tbd2-navhelp.liquid)
   Deux morceaux independants : la barre "Continuer tes achats" et le
   bouton "Haut de page". Chacun a son propre verrou d'amorcage, car la
   section peut etre presente DEUX FOIS sur une fiche produit : une fois
   dans le modele pour la barre, une fois dans le pied de page pour le
   bouton. Le script est donc charge deux fois — ne pas remettre un
   `return` global au debut, il tuerait le second morceau.

   Le seul reglage dont le script a besoin, le seuil d'apparition du
   bouton, arrive par l'attribut data-t2top-after.

   ------------------------------------------------------------------
   NOTE DE DEBOGAGE — 03/09/2026, A LIRE AVANT DE "REPARER" CE FICHIER
   ------------------------------------------------------------------
   Le bouton a semble casse pendant une heure. Il ne l'etait pas. Les
   onglets d'automatisation utilises pour le tester etaient en
   arriere-plan : document.visibilityState valait "hidden". Dans cet etat
   Chrome n'execute pas l'etape de rendu, donc il ne dispatche PAS les
   evenements `scroll`, ne livre PAS les IntersectionObserver, n'appelle
   PAS requestAnimationFrame et bride setInterval a 1 s. Aucun visiteur
   reel n'est dans cet etat.
   ⚠️ Avant de conclure qu'un script du theme est casse, verifier
   document.visibilityState et window.innerHeight dans l'onglet de test.
   ------------------------------------------------------------------ */

/* ==================================================================
   1. LA BARRE SUIT LE BLOC "COMPLETEZ VOTRE COLLECTION"
   ==================================================================
   Dan, 03/09/2026 : "met ca sous completez votre collection, en bas de
   page c'est inutile."

   Le probleme : la section `xsell` NE RESTE PAS a sa place. Son propre
   script la deplace a l'interieur de la section produit, entre le bloc
   methode (.t2sci) et l'apercu des cartes (.t2prev). Mesure sur la fiche
   Original : le bloc atterrit a 3 201 px alors que la fin du modele est a
   5 544 px. Mettre la barre apres `xsell` dans l'ordre du modele ne suffit
   donc PAS — elle reste en bas de page, loin derriere.
   ⚠️ Ne pas "corriger" en deplacant simplement la section dans le modele :
   ca a deja ete essaye, ca ne marche pas.

   Ici on replace donc la barre juste apres la section xsell, ou qu'elle
   soit allee. On re-verifie pendant 3 s, parce qu'on ne sait pas quand le
   script de xsell fait son deplacement, et parce qu'il pourrait le refaire.
   S'il n'y a pas de xsell sur la page, la barre reste ou le modele l'a
   mise : pas de saut, pas de trou. */
(function(){
  var bar = document.querySelector('.t2nh');
  if(!bar) return;
  var wrap = bar.closest('.shopify-section') || bar;
  if(wrap.dataset.t2nhPlaced) return;
  wrap.dataset.t2nhPlaced = '1';

  var tries = 0;
  (function place(){
    tries++;
    var xs = document.querySelector('[id$="__xsell"]');
    if(xs && xs.parentNode && xs.nextElementSibling !== wrap){
      xs.parentNode.insertBefore(wrap, xs.nextSibling);
    }
    if(tries < 12) setTimeout(place, 250);
  })();
})();

/* ==================================================================
   2. LE BOUTON "HAUT DE PAGE"
   ================================================================== */
(function(){
  var btn = document.querySelector('[data-t2top]');
  if(!btn || btn.dataset.booted) return;
  btn.dataset.booted = '1';

  var AFTER = parseInt(btn.getAttribute('data-t2top-after'), 10);
  if(!AFTER || AFTER < 0) AFTER = 700;
  var shifted = false;

  /* Le bouton s'ecarte d'une eventuelle bulle de chat, plutot que de parier
     sur une marge en dur : la hauteur de ces bulles varie d'un outil a l'autre
     et peut changer sans prevenir. */
  function avoid(){
    if(shifted) return;
    shifted = true;
    var me = btn.getBoundingClientRect();
    var all = document.querySelectorAll('body *');
    var lift = 0;
    for(var i = 0; i < all.length; i++){
      var el = all[i];
      if(el === btn || btn.contains(el)) continue;
      var cs;
      try { cs = getComputedStyle(el); } catch(e){ continue; }
      if(cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') continue;
      var r = el.getBoundingClientRect();
      if(!r.width || !r.height) continue;
      var over = r.left < me.right && r.right > me.left && r.top < me.bottom && r.bottom > me.top;
      if(over){
        var need = (me.bottom - r.top) + 12;
        if(need > lift) lift = need;
      }
    }
    if(lift > 0 && lift < 260) btn.style.bottom = (20 + lift) + 'px';
  }

  /* Le fondu a besoin d'une image intermediaire entre `hidden` retire et la
     classe posee, sinon la transition CSS n'a rien a interpoler. rAF est le
     bon outil, mais il ne s'execute jamais dans un onglet non rendu : d'ou le
     double appel, l'un ou l'autre passe, et show() est idempotent. */
  function next(fn){
    if(window.requestAnimationFrame) requestAnimationFrame(fn);
    setTimeout(fn, 60);
  }
  function show(){
    if(btn.hidden){
      btn.hidden = false;
      next(function(){ btn.classList.add('is-in'); avoid(); });
    } else {
      btn.classList.add('is-in');
    }
  }
  function hide(){ btn.classList.remove('is-in'); }

  function scrolled(){
    var el = document.scrollingElement || document.documentElement;
    return window.pageYOffset || el.scrollTop || 0;
  }
  function sync(){
    if(scrolled() > AFTER) show(); else hide();
  }

  /* ------------------------------------------------------------------
     TROIS DECLENCHEURS, ET C'EST VOLONTAIRE
     ------------------------------------------------------------------
     1. IntersectionObserver sur un temoin de 1 px pose a la hauteur du
        seuil. C'est le plus propre : aucun evenement `scroll` requis, et il
        continue de fonctionner si la page defile un jour dans un conteneur
        plutot que dans la fenetre.
     2. L'evenement `scroll`, pour les navigateurs sans IntersectionObserver.
     3. Un sondage a 250 ms. Il a l'air de trop, il ne l'est pas : c'est une
        simple lecture de scrollTop, sans calcul de mise en page, et c'est le
        seul des trois qui survive a un onglet non rendu ou a un script tiers
        qui absorberait les evenements. Le prix est nul, le filet est reel.
     Les trois appellent la meme fonction, qui est idempotente : ils ne
     peuvent pas se contredire.
     ⚠️ Ne pas "nettoyer" en n'en gardant qu'un. */
  var probe = document.createElement('div');
  probe.setAttribute('aria-hidden', 'true');
  probe.style.cssText = 'position:absolute;top:' + AFTER + 'px;left:0;width:1px;height:1px;pointer-events:none;opacity:0;';
  (document.body || document.documentElement).appendChild(probe);

  if(window.IntersectionObserver){
    new IntersectionObserver(function(entries){
      for(var i = 0; i < entries.length; i++){
        if(entries[i].isIntersecting) hide(); else show();
      }
    }).observe(probe);
  }

  var tick = false;
  window.addEventListener('scroll', function(){
    if(tick) return;
    tick = true;
    setTimeout(function(){ sync(); tick = false; }, 90);
  }, { passive: true });

  setInterval(sync, 250);
  sync();

  btn.addEventListener('click', function(){
    /* Une remontee animee de plusieurs milliers de pixels est exactement ce que
       prefers-reduced-motion sert a couper. */
    var soft = !window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var el = document.scrollingElement || document.documentElement;
    try { window.scrollTo({ top: 0, behavior: soft ? 'smooth' : 'auto' }); }
    catch(e){ window.scrollTo(0, 0); }
    if(!soft && scrolled() > 0){ el.scrollTop = 0; }
  });
})();
